var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-modal",
    { attrs: { active: this.showModal }, on: { close: _vm.handleClose } },
    [
      _c(
        "sc-modal-card",
        { staticClass: "config-modal-card", attrs: { title: _vm.title } },
        [
          _c(
            "template",
            { staticClass: "body", attrs: { slot: "body" }, slot: "body" },
            [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.onSubmitInstallation($event)
                    }
                  }
                },
                [
                  _c("app-config-form", {
                    ref: "appConfigForm",
                    attrs: { schemaBased: _vm.schemaBased }
                  }),
                  _vm._v(" "),
                  _c("sc-button", {
                    staticClass: "is-fullwidth",
                    attrs: {
                      theme: "primary",
                      text: _vm.formSaveButton,
                      disabled: _vm.loading
                    },
                    on: {
                      click: function() {
                        return _vm.onSubmitInstallation()
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bb1b1d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bb1b1d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-integrations/components/modal/config/ModalConfig.vue
// module id = null
// module chunks = 